import keyMirror from 'keymirror'

export default keyMirror({
  GET_REAL_TIME_METRICS_REQUEST: null,
  GET_REAL_TIME_METRICS_SUCCESS: null,
  GET_REAL_TIME_METRICS_FAILED: null,

  GET_MONTHLY_TRIP_STATISTICS_REQUEST: null,
  GET_MONTHLY_TRIP_STATISTICS_SUCCESS: null,
  GET_MONTHLY_TRIP_STATISTICS_FAILED: null,

  GET_MONTHLY_DIGITAL_KEY_STATISTICS_REQUEST: null,
  GET_MONTHLY_DIGITAL_KEY_STATISTICS_SUCCESS: null,
  GET_MONTHLY_DIGITAL_KEY_STATISTICS_FAILED: null,

  GET_MONTHLY_RIDER_STATISTICS_REQUEST: null,
  GET_MONTHLY_RIDER_STATISTICS_SUCCESS: null,
  GET_MONTHLY_RIDER_STATISTICS_FAILED: null,

  GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_REQUEST: null,
  GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_SUCCESS: null,
  GET_MONTHLY_RIDER_SUBSCRIPTIONS_STATISTICS_FAILED: null,

  GET_MONTHLY_ALERT_STATISTICS_REQUEST: null,
  GET_MONTHLY_ALERT_STATISTICS_SUCCESS: null,
  GET_MONTHLY_ALERT_STATISTICS_FAILED: null,

  GET_MONTHLY_PERS_ACTIVITY_STATISTICS_REQUEST: null,
  GET_MONTHLY_PERS_ACTIVITY_STATISTICS_SUCCESS: null,
  GET_MONTHLY_PERS_ACTIVITY_STATISTICS_FAILED: null,

  GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_REQUEST: null,
  GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_SUCCESS: null,
  GET_MONTHLY_DIRECT_VEHICLE_STATISTICS_FAILED: null,

  GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_REQUEST: null,
  GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_SUCCESS: null,
  GET_MONTHLY_RIDER_PERMANENT_SHARINGS_STATISTICS_FAILED: null,

  GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_REQUEST: null,
  GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_SUCCESS: null,
  GET_MONTHLY_RIDER_TEMPORARY_SHARINGS_STATISTICS_FAILED: null,

  GET_MONTHLY_COMPANY_STATISTICS_REQUEST: null,
  GET_MONTHLY_COMPANY_STATISTICS_SUCCESS: null,
  GET_MONTHLY_COMPANY_STATISTICS_FAILED: null,

  GET_CURRENT_DATA_COMPANY_STATISTICS_REQUEST: null,
  GET_CURRENT_DATA_COMPANY_STATISTICS_SUCCESS: null,
  GET_CURRENT_DATA_COMPANY_STATISTICS_FAILED: null,

  GET_CURRENT_RIDERS_STATISTICS_REQUEST: null,
  GET_CURRENT_RIDERS_STATISTICS_SUCCESS: null,
  GET_CURRENT_RIDERS_STATISTICS_FAILED: null,

  GET_RIDERS_DASHBOARD_STATISTICS_REQUEST: null,
  GET_RIDERS_DASHBOARD_STATISTICS_SUCCESS: null,
  GET_RIDERS_DASHBOARD_STATISTICS_FAILED: null,

  GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_REQUEST: null,
  GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_SUCCESS: null,
  GET_MONTHLY_MANUFACTURER_PERS_RECEPTION_STATISTICS_FAILED: null,

  GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_REQUEST: null,
  GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_SUCCESS: null,
  GET_MONTHLY_SUBCONTRACTOR_PERS_RECEPTION_STATISTICS_FAILED: null,

  GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_REQUEST: null,
  GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_SUCCESS: null,
  GET_MONTHLY_PRODUCED_VEHICLES_STATISTICS_FAILED: null,

  GET_DETAIL_REALTIME_ALERTS_REQUEST: null,
  GET_DETAIL_REALTIME_ALERTS_SUCCESS: null,
  GET_DETAIL_REALTIME_ALERTS_FAILED: null,

  UPDATE_FILTER_DETAIL_REALTIME_ALERTS_SUCCESS: null
})
